import { Button, Icon, Popup } from "semantic-ui-react";

const getWarningMsg = disposition => {
  if (!disposition) {
    return "";
  }

  const invalid = disposition?.invalid;
  const dnc = disposition?.dnc;

  if (dnc) {
    return "Disable all phone numbers.";
  }

  if (invalid) {
    return "Disable the current phone number.";
  }

  return "";
};

export function DispositionButton({
  disposition,
  dispositionId,
  disabled = false,
  handleClick,
}) {
  const hasPopup = disposition?.dnc || disposition?.invalid;
  const warningMsg = getWarningMsg(disposition);

  return (
    <Button
      size="tiny"
      disabled={disabled}
      content={disposition.displayName}
      className={`${dispositionId === disposition.id ? "gray" : "white"} disposition`}
      value={disposition}
      onClick={handleClick}
      icon={
        hasPopup ? (
          <Popup
            trigger={<Icon name="info circle" />}
            content={warningMsg}
            size="mini"
          />
        ) : undefined
      }
    />
  );
}
